import React from "react";

// Collection of all icons used in RegularAuctionGo
export const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 22H4V20C4 18.6739 4.52678 17.4021 5.46447 16.4645C6.40215 15.5268 7.67392 15 9 15H15C16.3261 15 17.5979 15.5268 18.5355 16.4645C19.4732 17.4021 20 18.6739 20 20V22ZM12 13C11.2121 13 10.4319 12.8448 9.7039 12.5433C8.97595 12.2417 8.31451 11.7998 7.75736 11.2426C7.20021 10.6855 6.75825 10.0241 6.45672 9.2961C6.15519 8.56815 6 7.78793 6 7C6 6.21207 6.15519 5.43185 6.45672 4.7039C6.75825 3.97595 7.20021 3.31451 7.75736 2.75736C8.31451 2.20021 8.97595 1.75825 9.7039 1.45672C10.4319 1.15519 11.2121 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7C18 8.5913 17.3679 10.1174 16.2426 11.2426C15.1174 12.3679 13.5913 13 12 13Z"
      fill="#646566"
    />
  </svg>
);

export const TimerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337Z"
      stroke="#C20102"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 5V10L13.3333 11.6667" stroke="#C20102" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ProxyBidIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.08353 1.75L17.3327 2.92917L18.511 11.1792L10.851 18.8392C10.6948 18.9954 10.4828 19.0832 10.2619 19.0832C10.0409 19.0832 9.82897 18.9954 9.6727 18.8392L1.4227 10.5892C1.26647 10.4329 1.17871 10.221 1.17871 10C1.17871 9.77903 1.26647 9.56711 1.4227 9.41083L9.08353 1.75ZM11.4402 8.82167C11.595 8.97641 11.7788 9.09914 11.981 9.18287C12.1832 9.26659 12.4 9.30967 12.6188 9.30963C12.8377 9.30959 13.0544 9.26644 13.2566 9.18264C13.4588 9.09885 13.6425 8.97605 13.7973 8.82125C13.952 8.66645 14.0748 8.4827 14.1585 8.28047C14.2422 8.07824 14.2853 7.8615 14.2852 7.64262C14.2852 7.42375 14.2421 7.20702 14.1583 7.00482C14.0745 6.80262 13.9517 6.61891 13.7969 6.46417C13.6421 6.30943 13.4583 6.18669 13.2561 6.10296C13.0539 6.01924 12.8371 5.97617 12.6182 5.97621C12.1762 5.97629 11.7523 6.15196 11.4398 6.46458C11.1273 6.77721 10.9517 7.20117 10.9518 7.64321C10.9519 8.08525 11.1276 8.50915 11.4402 8.82167Z"
      fill="#C20102"
    />
  </svg>
);

export const MinusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.16602 9.16699H15.8327V10.8337H4.16602V9.16699Z" fill="#092540" />
  </svg>
);

export const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16602 9.16699V4.16699H10.8327V9.16699H15.8327V10.8337H10.8327V15.8337H9.16602V10.8337H4.16602V9.16699H9.16602Z"
      fill="#092540"
    />
  </svg>
);
